module.exports = __webpack_public_path__ + "1_0_65/img/m1.89a79dc9.svg";